import { Component, ElementRef, HostListener, inject, OnDestroy } from '@angular/core';
import { LogOutService } from './shared/services/logOut/log-out.service';
import { filter, Subscription } from 'rxjs';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})

export class AppComponent implements OnDestroy{


  title = 'Portal Sala de Ventas';

  subscription: Subscription;
  broadcastService = inject(MsalBroadcastService);
  authService = inject(MsalService);

  
  constructor(private logOutService:LogOutService,private _elementRef: ElementRef, private msalBroadcastService: MsalBroadcastService) {
  }
  ngOnDestroy(): void {
    this.logOutService.logOutBackground();
  }

  @HostListener('window:unload', ['$event'])
  unloadHandler(event) {
    this.logOutService.logOutBackground();
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event) {
    this.logOutService.logOutBackground();
  }

  ngOnInit(): void {
    this._elementRef.nativeElement.removeAttribute("ng-version");
    this.msalBroadcastService.inProgress$         
    .pipe(         
      filter((status: InteractionStatus) => status === InteractionStatus.None),                
    )       
    .subscribe();
}

 
} 
     

    

